import { Button } from '@/shared/ui/Button';
import { FilterDropdown } from '@/shared/ui/FilterDropdown';
import type { FilterDropdownOption } from '@/shared/ui/FilterDropdown';
import { Icon } from '@/shared/ui/Icon';

import type { ConnectorStatusFilterValue } from '@/entities/connector';

import {
  ACTIVATION_FILTER_OPTIONS,
  STATUS_FILTER_OPTIONS,
} from '@/widgets/connectors/ConnectorTableContent/lib/connectorFilterOptions';

import styles from './ConnectorTableToolbar.module.css';

const renderFilterItem = (option: FilterDropdownOption<string | ConnectorStatusFilterValue>) => (
  <span>{option.label}</span>
);

type ConnectorTableToolbarProps = {
  hasSelected: boolean;
  selectedActivation: string[];
  selectedStatus: ConnectorStatusFilterValue[];
  onDelete: () => void;
  openCreateModal: () => void;
  onActivate: () => void;
  onDeactivate: () => void;
  onActivationFilterChange: (values: string[]) => void;
  onStatusFilterChange: (values: ConnectorStatusFilterValue[]) => void;
};

export const ConnectorTableToolbar = ({
  hasSelected,
  selectedActivation,
  selectedStatus,
  onDelete,
  openCreateModal,
  onActivate,
  onDeactivate,
  onActivationFilterChange,
  onStatusFilterChange,
}: ConnectorTableToolbarProps) => {
  return (
    <div className={styles.toolbar}>
      <div className={styles.filterSection}>
        <FilterDropdown
          buttonText="Activation"
          searchPlaceholder="Activation 검색..."
          selectedValues={selectedActivation}
          options={ACTIVATION_FILTER_OPTIONS}
          onSelectionChange={onActivationFilterChange}
          renderItem={renderFilterItem}
          showSearch={false}
          width={140}
        />
        <FilterDropdown<ConnectorStatusFilterValue>
          buttonText="Status"
          searchPlaceholder="Status 검색..."
          selectedValues={selectedStatus}
          options={STATUS_FILTER_OPTIONS}
          onSelectionChange={onStatusFilterChange}
          renderItem={renderFilterItem}
          showSearch={false}
          width={140}
        />
      </div>
      <div className={styles.actionsSection}>
        <Button
          variant="outlined"
          prefix={<Icon name="light" width={16} height={16} />}
          onClick={onDeactivate}
          disabled={!hasSelected}>
          비활성화
        </Button>
        <Button
          variant="outlined"
          prefix={<Icon name="light-on" width={16} height={16} />}
          onClick={onActivate}
          disabled={!hasSelected}>
          활성화
        </Button>
        <div className={styles.separator} />
        <Button
          variant="text"
          prefix={<Icon name="trash" width={16} height={16} />}
          onClick={onDelete}
          disabled={!hasSelected}>
          삭제
        </Button>
        <Button
          variant="filled"
          prefix={<Icon className={styles.plusIcon} name="plus-outlined" size={12} color="#fff" />}
          onClick={openCreateModal}>
          커넥터 생성
        </Button>
      </div>
    </div>
  );
};
